import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { DefaultButton } from '../../../../common/components/DefaultButton/DefaultButton'

import {
  ButtonsContainer,
  ContentContainer,
  Heading,
  Paragraph,
  StyledExclamationCircle,
} from './Shared'

interface Props {
  translationKey: string
  heading: string
  text?: string | ReactNode
  onContinueAsSelfPaying: () => void
  onBack: () => void
  fallbackInsurance?: () => void
}

const InsuranceVerificationFeedback: React.FC<React.PropsWithChildren<Props>> = ({
  translationKey,
  heading,
  text,
  onContinueAsSelfPaying,
  onBack,
  fallbackInsurance: fallbackInsurace,
}) => {
  const { t } = useTranslation()

  const hasFallbackInsurance = fallbackInsurace !== undefined

  return (
    <ContentContainer>
      <StyledExclamationCircle />
      <Heading>{heading}</Heading>
      {text && <Paragraph>{text}</Paragraph>}
      <ButtonsContainer>
        {hasFallbackInsurance && (
          <DefaultButton variant="contained" onClick={fallbackInsurace}>
            {t(`component.${translationKey}.customershipCheck.continueToFallbackInsurance`)}
          </DefaultButton>
        )}
        <DefaultButton
          variant={hasFallbackInsurance ? 'outlined' : 'contained'}
          onClick={onContinueAsSelfPaying}
        >
          {t(`component.${translationKey}.customershipCheck.continueAsSelfPaying`)}
        </DefaultButton>
        <DefaultButton variant={hasFallbackInsurance ? 'text' : 'outlined'} onClick={onBack}>
          {t('common.goBack')}
        </DefaultButton>
      </ButtonsContainer>
    </ContentContainer>
  )
}

export default InsuranceVerificationFeedback
